import { render, staticRenderFns } from "./lamsAuthBaseAccidentCategoryApproval.vue?vue&type=template&id=28eb920c&scoped=true&"
import script from "./lamsAuthBaseAccidentCategoryApproval.vue?vue&type=script&lang=js&"
export * from "./lamsAuthBaseAccidentCategoryApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb920c",
  null
  
)

export default component.exports